"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgIconMobile = function SvgIconMobile(props) {
  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    "aria-label": "mobile icon",
    fill: "currentColor",
    fillRule: "evenodd"
  }, props), /*#__PURE__*/_react.default.createElement("title", null, 'Mobile Icon'), /*#__PURE__*/_react.default.createElement("path", {
    d: "M33.545 34.91h-19.09V9.454h19.09zm-5.909 5.454h-7.272v-1.819h7.272zM31.273 4H16.727a5.455 5.455 0 00-5.454 5.455v29.09A5.455 5.455 0 0016.727 44h14.546a5.455 5.455 0 005.454-5.455V9.455A5.455 5.455 0 0031.273 4z"
  }));
};

var _default = SvgIconMobile;
exports.default = _default;